var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showExtras()
        ? _c(
            "v-expansion-panel",
            {
              staticClass: "no-shadow",
              attrs: { slot: "content", value: null },
              slot: "content"
            },
            [
              _c(
                "v-expansion-panel-content",
                {
                  staticClass: "extras-header",
                  staticStyle: { background: "transparent" }
                },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("h4", [_vm._v(_vm._s(_vm.$t("routeExtras.extraInfo")))])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", { staticClass: "click-action-info" }, [
                      _vm._v(
                        _vm._s(_vm.$t("routeExtras.clickToHighlightOnMap"))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.routeExtras, function(extra, extraKey) {
                    return [
                      _vm.showExtra(extraKey)
                        ? _c(
                            "v-layout",
                            { key: extraKey, attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs10: "", sm11: "" } },
                                [
                                  _c("v-list", [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { padding: "0 0 0 10px" }
                                      },
                                      [
                                        _c("h5", [
                                          _vm._v(
                                            _vm._s(_vm.$t("global." + extraKey))
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "extra-bar" },
                                          [
                                            _vm._l(
                                              _vm.routeExtras[extraKey].summary,
                                              function(summary, index) {
                                                return [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      key: index + extraKey,
                                                      attrs: {
                                                        disabled:
                                                          _vm.$lowResolution,
                                                        top: ""
                                                      }
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass: "segment",
                                                        style: _vm.segmentStyle(
                                                          extraKey,
                                                          summary,
                                                          index
                                                        ),
                                                        attrs: {
                                                          slot: "activator"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.showSection(
                                                              extraKey,
                                                              summary.value,
                                                              index
                                                            )
                                                          }
                                                        },
                                                        slot: "activator"
                                                      }),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.getExtraValueLabel(
                                                              extraKey,
                                                              summary.value
                                                            )
                                                          ) +
                                                          " - " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "routeExtras.clickToHighlightOnMap"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs2: "", sm1: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "show-all-on-map",
                                      attrs: {
                                        "max-width": 30,
                                        fab: "",
                                        icon: "",
                                        title: _vm.$t(
                                          "routeExtras.showAllOnMap"
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.showAllSections(extraKey)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("remove_red_eye")])],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-647f9bda", { render: render, staticRenderFns: staticRenderFns })
  }
}